module.exports = __webpack_public_path__ + "media/images/temp/ribbon-12-61833d0e4bf6f2b6c008985802701567.png";